import numeral from 'numeral';
import { coinConfig, currencyConfig } from '../config/currency.config';

// ----------------------------------------------------------------------

export function fNumber(number) {
    return numeral(number).format();
}
export function fUsd(number) {
    return numeral(Number(number) / 100).format('$0.00');
}

function fCurrency(number) {
    const safe = Number(number) || 0;
    return numeral(safe / 100).format('0,0.00');
}

export function formatCurrency(amount, currencyCode) {
    if (amount === null) {
        return fCurrency(0);
    }

    const config = currencyConfig[currencyCode];

    if (!config) {
        return fCurrency(amount);
    }

    const formattedAmount = (Number(amount) / 100).toFixed(config.precision);
    const parts = formattedAmount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, config.thousand);

    // Non-breaking spaces, between the amount and its symbol and in a space
    // thousands separator: "10,00 €" wrapped the € onto a line of its own in
    // narrow columns.
    return config.format
        .replace('%s', config.symbol)
        .replace('%v', parts.join(config.decimal))
        .replace(/ /g, '\u00A0');
}
export function fCryptoCurrency(amount) {
    return amount ? numeral(Number(amount)).format('0,0.000000') : numeral(0).format('0,0.000000');

}

export function formatCryptoCurrency(amount, coin) {
    const config = coinConfig[coin];

    if (!config) {
        return fCryptoCurrency(amount);
    }

    const precision = config.precision || 6;
    const thousand = config.thousand || ',';
    const formattedAmount = Number(amount).toFixed(precision);
    const parts = formattedAmount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousand);

    return config.format
        .replace('%s', config.symbol)
        .replace('%v', parts.join(config.decimal));
}

export function currencyToCents(number) {
    return number ? numeral(Number(number)).multiply(100).value() : 0;
}

export function centToCurrency(number) {
    return number ? numeral(Number(number) / 100).format('0,0.00') : '';
}


// Up to four decimals, none when they are zero: '0.0%' showed 1.25 as 1.3%, and
// stripping '.0' afterwards turned 10.05% into 105%. `signed` puts a + on a
// positive value, for adjustments where the direction is the point.
export function fPercent(number, { signed = false } = {}) {
    if (!number) return '';

    return numeral(Number(number) / 100).format(signed ? '+0.[0000]%' : '0.[0000]%');
}

export function fShortenNumber(number) {
    const format = number ? numeral(number).format('0.00a') : '0.00';

    return result(format, '.00');
}

export function fData(number) {
    const format = number ? numeral(number).format('0.0 b') : '';

    return result(format, '.0');
}

function result(format, key = '.00') {
    const isInteger = format.includes(key);

    return isInteger ? format.replace(key, '') : format;
}

export const formatPhoneNumberForUi = (rawPhoneNumber) => {
    try {
        if (!rawPhoneNumber) return;
        if (rawPhoneNumber.length < 3) return rawPhoneNumber;

        const phoneNumber = rawPhoneNumber.replace(/\D/g, '');
        const countryCode = getCountryCode(phoneNumber);
        const config = countryCodesConfig[countryCode];

        if (!config) {
            return rawPhoneNumber;
        }

        const { prefix, mask, length } = config;
        const number = phoneNumber.slice(prefix.length, length);
        let position = 0;
        return mask.replace(/9/g, () => number[position++] || '');
    } catch (error) {
        return rawPhoneNumber;
    }
};

export const formatPhoneNumberForApi = (rawPhoneNumber) => {
    // returns the phone number in the format +79999999999
    return rawPhoneNumber?.replace(/\D/g, '');
};

const countryCodesConfig = {
    RU: {
        code: 'RU',
        prefix: '7',
        mask: '+7 (999) 999-99-99',
        length: 11
    },
    MD: {
        code: 'MD',
        prefix: '373',
        mask: '+373 (999) 99-999',
        length: 11
    },
    RO: {
        code: 'RO',
        prefix: '40',
        mask: '+40 (999) 999-999',
        length: 12
    },
    BG: {
        code: 'BG',
        prefix: '359',
        mask: '+359 (999) 999-999',
        length: 12
    },
    US: {
        code: 'US',
        prefix: '1',
        mask: '+1 (999) 999-9999',
        length: 11
    },
    CA: {
        code: 'CA',
        prefix: '1',
        mask: '+1 (999) 999-9999',
        length: 11
    }
};
const getCountryCode = (phoneNumber) => {
    return Object.keys(countryCodesConfig).find((code) => {
        const { prefix } = countryCodesConfig[code];
        return phoneNumber.startsWith(prefix);
    });
};
